import dayjs from "dayjs";

import { AppointmentSlot } from "~/types/appointment";

export const getSlotsForDay = (
  slots: AppointmentSlot[] | null | undefined,
  day: Date | string | null
) => {
  if (!day || !slots) return [];
  const filteredSlots = slots?.filter(slot => {
    return dayjs(slot.startTime).isSame(day, "date");
  });

  return filteredSlots
    ?.sort((a, b) => a.startTime.getTime() - b.startTime.getTime())
    ?.map(slot => {
      return {
        id: slot.id,
        startHour: slot.startTime.getHours(),
        startMinute: slot.startTime.getMinutes(),
        endHour: slot.endTime.getHours(),
        endMinute: slot.endTime.getMinutes(),
        startTime: slot.startTime.toISOString(), // Full ISO string for unique identification
      };
    });
  // console.log("filtered slots", filteredSlots);
};
